export default __webpack_public_path__ + "static/media/brand.a9939e12.png";